import { render, staticRenderFns } from "./AddBatchPviForm.vue?vue&type=template&id=eb5c477e&"
import script from "./AddBatchPviForm.vue?vue&type=script&lang=js&"
export * from "./AddBatchPviForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports